import { Component } from '@angular/core'
import { Params, Router } from '@angular/router'
import { HTMLInputEvent } from '../../../shared/interfaces/html-input-event.interface'

@Component({
  template: 'NO UI TO BE FOUND HERE!'
})
export class ToolsCatalogueListComponent {
  currentPath: string
  queryParams: Params

  selectedOptions: {
    label: string
    value: number | string
    queryParam: string
    filterTitle
  }[] = []

  constructor(private router: Router) {}

  filter({ propName, value }: { propName: string; value: any }) {
    const queryParams: Params = {
      [propName]: value
    }

    if (propName !== 'page') {
      queryParams.page = '1'
    }

    this.router.navigate([this.currentPath], {
      queryParams,
      queryParamsHandling: 'merge'
    })
  }

  goToPage(pageNumber: number) {
    this.filter({ propName: 'page', value: pageNumber.toString() })
  }

  onSort(event: HTMLInputEvent) {
    this.filter({ propName: 'orderBy', value: event.target.value })
  }

  removeSelectedOption(option: { value: number | string; queryParam: string }) {
    let optionValue: string | string[] = this.queryParams[option.queryParam]

    if (typeof optionValue === 'string') {
      optionValue = [optionValue]
    }

    this.filter({
      propName: option.queryParam,
      value: optionValue.filter(
        (value: string) => String(value) !== String(option.value)
      )
    })
  }
}
